var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"router-breadcrumb",attrs:{"separator":"/"}},_vm._l((_vm.$route.matched),function(route){return (route.path != '/')?_c('el-breadcrumb-item',{key:route.path,attrs:{"to":route.path}},[_vm._v(_vm._s(route.meta.name))]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }